import { LegacyIIQApi } from '../legacy-iiq-api'

export const getMarketingDatesCommodities =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (query: Record<string, any> = {}) =>
    api
      .get('/fieldOptions/marketingDatesCommodities', query)
      .then(res => res?.data)

export const getCoverageValues =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (query: Record<string, any> = {}) =>
    api.get('/fieldOptions/coverageValues', query).then(res => res?.data)

export const getAllPreviousLgmSalesEffectiveDates =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  () =>
    api.get('/fieldOptions/lgmSalesEffectiveDate')
